// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"ModalPageContent_desktopImg__oxfgI","mobileImg":"ModalPageContent_mobileImg__jm42k","el":"ModalPageContent_el__aSZXq","container":"ModalPageContent_container__X_u2Q"};